/**
 * FCM token tablosundan platform (Android / iOS / Web) dağılımını hesaplar.
 *
 * Neden ayrı bir helper?
 *  - Eski kod satırları çekip JS tarafında sayıyordu. $top limiti (2000 / 10000)
 *    tabloyu kırpıyordu; tablo 5.700+ satıra çıkınca sayılar hem yanlış hem de
 *    sayfadan sayfaya farklı çıkıyordu.
 *  - Burada sayım OData $count / $apply ile sunucuda yapılıyor: kırpılma yok,
 *    payload yok, her sayfada aynı sonuç.
 */

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";
const ENTITY = "KULLANICI_FCM_TOKENLERI";

const AKTIF = "AKTIF eq true";
const startsWith = (p) => `startswith(tolower(CIHAZ_MODEL),'${p}')`;
const IOS = `${AKTIF} and ${startsWith("ios")}`;
const ANDROID = `${AKTIF} and ${startsWith("android")}`;
const WEB = `${AKTIF} and ${startsWith("web")}`;

/** /$count düz metin döner, başında BOM olabiliyor. */
const count = async (filter, opts) => {
  const res = await fetch(
    `${BASE_URL}/${ENTITY}/$count?$filter=${encodeURIComponent(filter)}`,
    { cache: "no-store", ...opts }
  );
  if (!res.ok) throw new Error(`count failed: ${res.status}`);
  const text = (await res.text()).replace(/^﻿/, "").trim();
  const n = Number(text);
  return Number.isFinite(n) ? n : 0;
};

/** Aynı kullanıcının birden fazla token kaydı tek kişi sayılsın diye. */
const distinctUsers = async (filter, opts) => {
  const apply =
    `filter(${filter})/aggregate(KULLANICI_ID with countdistinct as adet)`;
  const res = await fetch(
    `${BASE_URL}/${ENTITY}?$apply=${encodeURIComponent(apply)}`,
    { cache: "no-store", ...opts }
  );
  if (!res.ok) throw new Error(`distinct failed: ${res.status}`);
  const json = await res.json();
  return Number(json?.value?.[0]?.adet) || 0;
};

/**
 * @returns {{
 *   toplamToken:number, ios:number, android:number, web:number, diger:number,
 *   toplamKullanici:number, iosKullanici:number, androidKullanici:number
 * }}
 */
export const fetchPlatformStats = async (opts) => {
  const [
    toplamToken, ios, android, web,
    toplamKullanici, iosKullanici, androidKullanici,
  ] = await Promise.all([
    count(AKTIF, opts),
    count(IOS, opts),
    count(ANDROID, opts),
    count(WEB, opts),
    distinctUsers(AKTIF, opts),
    distinctUsers(IOS, opts),
    distinctUsers(ANDROID, opts),
  ]);

  return {
    toplamToken,
    ios,
    android,
    web,
    // CIHAZ_MODEL boş / tanınmayan kayıtlar: eskiden sessizce Android'e ekleniyordu.
    diger: Math.max(0, toplamToken - ios - android - web),
    toplamKullanici,
    iosKullanici,
    androidKullanici,
  };
};

export default fetchPlatformStats;
